<template>
  <el-dropdown size="small" class="d2-mr">
    <!-- 未登录 -->
    <span class="btn-text">{{deptname}}_{{username}} 欢迎您！</span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item @click.native="logOff">
        <d2-icon name="power-off" class="d2-mr-5"/>
        注销
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { GetMenus } from '@/api/allactions'
export default {
  data: function () {
    return {
      menuAsidesAll:[],
    }
  },
  computed: {
    ...mapState('d2admin/user', [
      'info'
    ]),
     username() {
      let username = localStorage.getItem("top_username");
      return username;
    },
     deptname() {
      let deptname = localStorage.getItem("ms_deptname");
      return deptname;
    }
  },
  mounted: function () {
    GetMenus().then((res) =>{
      this.renrenMenuToD2AdminMenu(res.data[0].children)
      this.$store.commit('d2admin/menu/asideSet', this.menuAsidesAll)
    })
  },
  methods: {
    ...mapActions('d2admin/account', [
      'logout'
    ]),
    /**
     * @description 登出
     */
    logOff () {
     this.logout({
        confirm: true
      })
    },
    renrenMenuToD2AdminMenu (menuArray,routeNameDict) {
      const transform = menu => ({
        ...menu.children.length > 0 ? { children: menu.children.map(e => transform(e)) } : {},
        id: menu.id,
        icon: menu.icon,
        title: menu.name,
        name: menu.name,
        path: menu.url
      })
      this.menuAsidesAll = menuArray.map(e => transform(e))
      return menuArray.map(e => transform(e))
    }
  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
